export const PRODUCT_INFO_CATEGORIES: {
  id: ProductCategoryId;
  label: string;
}[] = [
  {
    id: 'description',
    label: 'Thông tin chung',
  },
  {
    id: 'ingredients',
    label: 'Thành phần',
  },
  {
    id: 'indication',
    label: 'Chỉ định',
  },
  {
    id: 'contraindication',
    label: 'Chống chỉ định',
  },
  {
    id: 'dosage',
    label: 'Liều lượng - cách dùng',
  },
  {
    id: 'drugInteraction',
    label: 'Tương tác thuốc',
  },
  {
    id: 'storage',
    label: 'Bảo quản',
  },
  {
    id: 'drugOverdose',
    label: 'Quá liều',
  },
];

export type ProductCategoryId =
  | 'description'
  | 'ingredients'
  | 'indication'
  | 'dosage'
  | 'contraindication'
  | 'drugInteraction'
  | 'storage'
  | 'drugOverdose';
